import { useBreakpoint } from '@insify/react-hooks';

import { useProfile } from '../../../api/queries/useProfile';
import { AssistantAnnouncementBanner } from '../../../components/AssistantAnnouncementBanner/AssistantAnnouncementBanner';
import { CenterAlignedContainer } from '../../../components/CenterAlignedContainer';
import { FrenchHealthInsuranceOfferBanner } from '../../../components/CrossSell';
import { HomepagePolicyList } from '../../../components/HomepagePolicyList';
import { getAppDomain } from '../../../utils/localize';

import styles from './styles.module.css';

const HomePage: React.FC = () => {
  const { data: profile } = useProfile();
  const isMobile = !useBreakpoint('(min-width: 960px)');

  if (profile === undefined) {
    return;
  }

  return (
    <CenterAlignedContainer>
      <div className={styles.grid}>
        {getAppDomain() === 'nl' && !isMobile && <AssistantAnnouncementBanner />}
        <HomepagePolicyList />
        <FrenchHealthInsuranceOfferBanner />
      </div>
    </CenterAlignedContainer>
  );
};

export { HomePage };
